import {
  type CartValue,
  cartAppendAnnotations
} from '@ecomm/data-simplisafe-api'
import { getCartId } from '@ecomm/data-storage'
import { voidFn } from '@simplisafe/ewok'
import * as E from 'fp-ts/lib/Either'
import * as O from 'fp-ts/lib/Option'
import { pipe } from 'fp-ts/lib/function'
import { useCallback } from 'react'
import { useSetCart } from '../atoms/useCart'

/**
 * Adds annotation to cart.
 * @returns A function that adds annotation to cart.
 */
export const useCartAppendAnnotations = () => {
  const cartId = getCartId()
  const setCart = useSetCart()

  return useCallback(
    (
      annotations: readonly string[],
      onFailure?: () => void,
      onSuccess?: () => void
    ) => {
      const fn = async (id: string) => {
        const cart = await cartAppendAnnotations(id, annotations)()
        pipe(
          cart,
          E.fold(
            () => {
              onFailure && onFailure()
            },
            (t: CartValue) => {
              setCart(['update_cart', t])
              onSuccess && onSuccess()
            }
          )
        )
      }
      pipe(
        O.fromNullable(cartId),
        O.fold(() => voidFn(), fn)
      )
    },
    [cartId, setCart]
  )
}
